/*
 * @Descripttion: 三级品类树--多选
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useCallback, useState } from "react";
import styles from "./index.module.scss";
import { Button, Tree } from "@alifd/next";
import LzDialog from "@/components/common/LzDialog";

/**
 * opType 固定为 'ALL'
 * @param changeData-把组件的值提交到父组件，改变父组件的值
 * @param tagItem-整个标签的信息
 */
const TagCategories = ({ tagItem = {}, changeData = (data) => {} }:any, values = {}) => {
  const TreeNode = Tree.Node;
  const [allTags, setAllTags]: any = useState([]);
  const [isShow, setIsShow] = useState(false);
  const [selectedTagsId, setSelectedTagsId]: any = useState(tagItem.opValue?.ids ? tagItem.opValue?.ids : []);

  /**
   * 勾选或取消勾选复选框时触发的回调函数
   */
  const onCheck = (keys, info) => {
    setSelectedTagsId(keys);
  };

  /**
   * 获取三级类目数据
   */
  const getThreelevel = () => {
    const result = tagItem?.value?.map((i1) => {
      return {
        level: 1,
        key: i1?.param_id,
        label: i1?.param_name,
        children: i1?.sub_param_list?.map((i2) => {
          return {
            level: 2,
            key: Number(i2.param_id),
            label: i2.param_name,
          };
        }),
      };
    });
    setAllTags(result);
  };

  /**
   * 展示选择三级类目的弹窗
   */
  const showWdDialog = () => {
    setIsShow(true);
    getThreelevel();
  };

  /**
   * 直接取消关闭(勾选与否并不保存)
   */
  const cancel = () => {
    setIsShow(false);
  };

  /**
   * 选择完毕关闭弹窗
   */
  const confirm = () => {
    const temp = JSON.parse(JSON.stringify(new Array(allTags.length).fill([])));
    const sourceName = temp.map((i, index) => {
      return {
        param_id: [allTags[index]?.key],
        param_name: allTags[index]?.label,
        sub_param_list: [],
      };
    });
    allTags.forEach((i, index) => {
      i.children.forEach((i2, index2) => {
        if (selectedTagsId.includes(i2.key)) {
          sourceName[index].sub_param_list.push({
            param_id: i2.key,
            param_name: i2.label,
          });
        }
      });
    });
    // 找出sourceName中，二级类目为空的项，并删除
    sourceName.forEach((i, index) => {
      if (i.sub_param_list.length === 0) {
        sourceName.splice(index, 1);
      }
    });
    changeData({
      opValue: {
        label_id: tagItem?.id,
        param_list: sourceName,
        ids: selectedTagsId,
      },
      opType: "ALL",
    });
    setIsShow(false);
  };

  const tagNumbers = useCallback(() => {
    console.log("tagItem.opValue", tagItem);
    if (tagItem?.opValue) {
      // 计算出tagItem.opValue.param_list中，二级类目的数量
      const count = tagItem?.opValue?.param_list?.reduce((pre, cur) => {
        return pre + cur.sub_param_list.length;
      }, 0);
      // 如果二级类目的数量大于0，则显示“已选X个”，否则显示“已选0个”
      const selectedCount = count > 0 ? count : 0;
      return selectedCount;
    }
  }, [tagItem?.opValue]);

  const tagNames = useCallback(() => {
    if (tagItem?.opValue) {
      // 拼接出tagItem.opValue.param_list中，一级类目和二级类目的名称，用斜线拼接一二级名称，用逗号分隔每一组名称
      const selectedNames = tagItem?.opValue?.param_list?.map((i) => i.sub_param_list.map((i2) => i.param_name + "/" + i2.param_name)).join("；") ?? "";
      return selectedNames;
    }
  }, [tagItem?.opValue]);

  return (
    <div>
      <div className={`${styles["tag-categories"]} tag-width`}>
        <div className={styles["special-tag-wd"]} onClick={showWdDialog}>
          {/* 选择（已选<span>{tagNumbers() ?? 0}</span>个） &gt;&gt; */}
          选择（已选<span>{selectedTagsId.length ?? 0}</span>个） &gt;&gt;
        </div>
        
        {selectedTagsId.length <= 0 && (
          <div style={{ color: "#f33" }} className={`iconfont icon-icon4-30 ${styles["tag-error-select"]}`}>
            请选择{tagItem.labelDescription}
          </div>
        )}
        <div>{tagNames()}</div>
        <LzDialog className={"my-dialog"} footer={false} isFullScreen shouldUpdatePosition title="选择三级类目" visible={isShow} onCancel={cancel} onClose={cancel}>
          <Tree
            checkable
            defaultExpandedKeys={selectedTagsId[0] ? Array.of(selectedTagsId[0]) : []}
            defaultCheckedKeys={selectedTagsId}
            onCheck={onCheck}
            dataSource={allTags}
            showLine
            checkedStrategy={"child"}
            style={{ maxHeight: "500px", overflow: "auto" }}
          />

          <div style={{ textAlign: "right" }}>
            <Button type="secondary" className={`submit-btn ${styles.mr10}`} onClick={confirm}>
              确认
            </Button>
            <Button type="normal" className={"cancel-btn"} onClick={cancel}>
              取消
            </Button>
          </div>
        </LzDialog>
      </div>
    </div>
  );
};
export default TagCategories;
